<template>
  <div >
     
    <span class="line-left mb-3"><b> {{ $t('blog.popularTags') }}</b></span><br>
      <button class="btn-sm btn-light-secondary  m-1 btn-pill" v-for="item of TagsButton" :key="item.id">
        
     
          {{ item.text }}
     
         
      </button>
       
    </div>
</template>

<script>
export default {
  props:[
    "TagsButton"
  ],
  data() {
    return {
       
    };
  },
  methods: {
     
     
  },
};
</script>

<style scoped>

.heart-animation {
  z-index: 9999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5rem;
  color: rgb(255, 255, 255);
  opacity: 0;
  animation: none;
}


.heart-animation.active {
  animation: heart-pop 1s ease-out forwards;
}

@keyframes heart-pop {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.7);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

.icon-button {
  background: var(--white);
  color: var(--black);
  border: none;
  padding: 3px;
  border-radius: 5px;
  width: 2.2rem;
  height: 2.2rem;
  font-size: 18px;
  cursor: pointer;
  outline: none;
}
.action-buttons {
  position: absolute;
  bottom:30px;
  right: 10px;
  /* display: flex; */
  gap: 10px;
}
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent; 
  /* border-radius: 0px; */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: transparent; 
}
.product-gallery {
  /* overflow: hidden;
  
  display: flex;
  flex-direction: column;
  align-items: center; */


 

  position: relative;
  width: 100%;
  /* max-width: 400px; */
 
  overflow: hidden;
}

.carousel-wrapper {
  width: 100%;
  /* max-width: 100%; */
  margin-bottom: 15px;
}

.image-container {
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
}

.main-image {
  position: relative;

  width: 100vw;
  max-width: 800px;
  /* min-height: 800px; */
  max-height: 100%;
  /* border-radius: 8px; */
}

.thumbnails-wrapper {
  display: flex;
  /* width: 100vh !important; */
  align-items: center;
}

.thumbnails {
  width: 100vw !important;
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px;
  scroll-behavior: smooth;
}

.thumbnail {
  width: 8rem;
  /* width: 100vh !important; */
  height: 6rem;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s;
  /* border-radius: 4px; */
}

.thumbnail.active {
  /* border-color: #007bff; */
}

.thumbnail:hover {
  /* border-color: #0056b3; */
}

.nav-button {
  margin-top: -1rem;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  border-radius: 100px !important;
  transition: color 0.2s;
}
 @media (max-width: 576px) {
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30vh;
  }
} 
 @media (max-width: 720px) {
  .main-image {
height: 20vh;
  width: 100vw;
  /* max-width: 100%; */
  height: 100%;
  /* border-radius: 8px; */
}
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vh !important;
  }
} 

 
</style>